import React from 'react';
import StatusBadge from './StatusBadge';
import { formatDateTime } from '../../../Common/utils';

export default function TableRow ({ id, title, address, phone, createdAt, isActive }) {
    return (
        <tr>
            <th scope="row">
                {/* <Link to={routes.ESTABLISHMENT} params={{ id }}>{title}</Link> */}
                {title}
            </th>
            <td>
                <span>{!!address ? `${address.address}, ${address.number ? address.number : 'S/N'}` : ''}</span>
                <span className="small d-block">{!!address ? address.neighborhood : ''}</span>
            </td>
            <td>{!!address ? `${address.city} ${address.state}` : ''}</td>
            <td>{phone}</td>
            <td>{formatDateTime(createdAt)}</td>
            <td>
                <StatusBadge status={isActive} />
            </td>
            {/* <td className="text-right">
                <OptionsMenu id={id} />
            </td> */}
        </tr>
    );
}




// WEBPACK FOOTER //
// ./src/components/Pages/Establishments/TableRow.js